import { render, staticRenderFns } from "./DatagateConsent.vue?vue&type=template&id=5ca7cf00&scoped=true"
import script from "./DatagateConsent.vue?vue&type=script&lang=js"
export * from "./DatagateConsent.vue?vue&type=script&lang=js"
import style0 from "./DatagateConsent.vue?vue&type=style&index=0&id=5ca7cf00&prod&lang=scss"
import style1 from "./DatagateConsent.vue?vue&type=style&index=1&id=5ca7cf00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca7cf00",
  null
  
)

export default component.exports